/* eslint-disable */
import { auth } from '@/plugins/auth/firebase'
import axios from 'axios'
import Vue from 'vue'
import * as vars from '@/vars.json';

export const cms = {
  namespaced: true,
  state: {
    currentItem: {},
    isLoading: false,
    posts:[],
    static_pages: [],
    faqs: [],
    currentPost:{},
    loading:false,
    writing:false,
    shopMultimedia: [],
    shopPosts: [],
    shopAbout: [],
  },

  mutations: {
      setLoading (state, payload){
        state.loading = payload
      },
      setWriting (state, payload){
        state.writing = payload
      },
      setError (state, payload){
        state.error = payload;
      },
      clearError (state){
        state.error = null
      },
      createPost (state, payload){
        state.posts.push(payload)
      },
      createAd (state, payload){
        state.advertisements.push(payload)
      },
      loadPosts ( state, payload){
        state.posts = payload;

      },
      loadStatic ( state, payload){
        state.static_pages = payload;
      },
      loadFaqs ( state, payload){
        state.faqs = payload;
      },
      loadShopPosts ( state, payload){
        state.shopPosts = payload;

      },
      loadShopAbout ( state, payload){
        state.shopAbout = payload;
      },
      loadShopMultimedia ( state, payload){
        state.shopMultimedia = payload;
      },

      setPost(state,payload){
        state.currentPost = payload;
      },

  },

  actions: {
    createItem({commit},payload) {
      return new Promise((resolve, reject) => {

        let path;
        let type = payload.context;
        if(type === 'post' || type === 'posts') {
          path = 'posts';
        }
        else if(type ==='static') {
          path = 'static';
        } else {
          path = type;
        }
        if(path !== 'static' && path !== 'posts') {
          payload.data.type = 'Banner'
        }
        let itemData = {
          username: payload.data.username || null,
          subject: payload.data.subject || null,
          type: payload.data.type,
          title: payload.data.title || null,
          content: payload.data.content || null,
          icon: payload.data.icon ||null,

        };

        let itemsRef = firebase.database().ref().child(path);
        let imageRef = firebase.storage().ref().child(path+'/image');
        let audioRef = firebase.storage().ref().child(path+'/audio');
        let contentRef = firebase.storage().ref().child(path+'/content');
        let key;
        let imageUrl;
        let audioUrl;
        let contentUrl;
        // console.log(itemData);
        //poner condicional para casos en que la publicidad sea tipo banner o sea tipo video
        itemsRef.push(itemData)
          .then((data)=>{
            key = data.key;
            return key;
          })
          .then(key=>{
            if( payload.data.type !=='Video'){
              // console.log('no es video, hay una imagen');
              return imageRef.child(key).putString(payload.data.image,"data_url");
            }
          })
          .then(()=>{
            if( payload.data.type !=='Video'){
              return  imageRef.child(key).getDownloadURL()
            }
          })

          .then(downloadPath =>{
            if( payload.data.type !=='Video'){
              imageUrl = downloadPath;
              return itemsRef.child(key).update({image : imageUrl});
            }
          })
          .then(()=>{
            // console.log(payload.data.audio);
            if( payload.data.audio){

              return audioRef.child(key).putString(payload.data.audio,"data_url");
            }
          })
          .then(()=>{
            if( payload.data.audio){
              return  audioRef.child(key).getDownloadURL();
            }
          })
          .then(downloadPath =>{
            if( payload.data.audio){
              audioUrl = downloadPath;
              return itemsRef.child(key).update({audio : audioUrl});
            }
          })
          // .then(()=>{
          //   if( payload.data.type !=='Video' && payload.data.type !== 'Banner'){
          //     // console.log('no es video, hay una imagen, tampoco un banner, hay contenido');
          //     return contentRef.child(key).putString(payload.data.content);
          //   }
          // })
          // .then(()=>{
          //   if( payload.data.type !=='Video' && payload.data.type !== 'Banner'){
          //     return  contentRef.child(key).getDownloadURL()
          //   }
          // })
          // .then(downloadPath =>{
          //   if( payload.data.type !=='Video' && payload.data.type !== 'Banner'){
          //     contentUrl = downloadPath;
          //     return itemsRef.child(key).update({content : contentUrl})
          //   }
          // })

          .then(()=>{

            resolve();
          })
          .catch((error) => {
            // console.log(error);

            reject();
          });
      })
    },
    updateItem({commit}, payload) {
      // return // console.log(payload);
      return new Promise((resolve, reject) => {
        // let path;
        let path = payload.context;
        // console.log(path );
        if (path !== 'static' && path !== 'posts') {
          payload.data.type = 'Banner'
        }
        let itemData = {
          username: payload.data.username || null,
          subject: payload.data.subject || null,
          type: payload.data.type,
          title: payload.data.title || null,
          content: payload.data.content || null,
          icon: payload.data.icon ||null,

        };


        let itemsRef = firebase.database().ref().child(path);
        let imageRef = firebase.storage().ref().child(path+'/image');
        let audioRef = firebase.storage().ref().child(path+'/audio');
        let audioUrl;
        let contentRef = firebase.storage().ref().child(path+'/content');
        // console.log(payload.data, payload.data.type );
        let promises = [];
        itemsRef.child(payload.data.id).update(itemData)
          .then(() =>{
            if( payload.data.type !=='Video'){
              if( payload.data.image.startsWith("https://") ){
                //is the same image as the url stills there
              }else{
                return imageRef.child(payload.data.id).putString(payload.data.image,"data_url");
              }
            }else{

              promises.push(imageRef.child(payload.data.id).delete());
            }
          })
          .then(()=>{
            if( payload.data.type !=='Video')
              return imageRef.child(payload.data.id).getDownloadURL();
          })
          .then(downloadPath =>{
            if( payload.data.type !=='Video')
              return itemsRef.child(payload.data.id).update({image : downloadPath});
            else{
              promises.push(itemsRef.child(payload.data.id).update({image : null}));
            }
          })
          .then(() =>{
            if(payload.data.audio){
              if( payload.data.audio.startsWith("https://") ){
                //is the same audio as the url stills there
              }else{
                return audioRef.child(payload.data.id).putString(payload.data.audio,"data_url");
              }
            }
          })
          .then(()=>{
            // console.log(payload.data.audio);
            if(payload.data.audio){
              if( !payload.data.audio.startsWith("https://")){
                return audioRef.child(payload.data.id).putString(payload.data.audio,"data_url");
              }
            }
          })
          .then(()=>{
            if( payload.data.audio){
              if( !payload.data.audio.startsWith("https://")){

                return  audioRef.child(payload.data.id).getDownloadURL();
              }
            }
          })
          .then(downloadPath =>{
            if( payload.data.audio){
              if( !payload.data.audio.startsWith("https://")){
                audioUrl = downloadPath;
                return itemsRef.child(payload.data.id).update({audio : audioUrl});
              }
            }
          })
          .then(()=>{
            if( payload.data.type !=='Video')
              return imageRef.child(payload.data.id).getDownloadURL();
          })
          .then(downloadPath =>{
            if( payload.data.type !=='Video')
              return itemsRef.child(payload.data.id).update({image : downloadPath});
            else{
              promises.push(itemsRef.child(payload.data.id).update({image : null}));
            }
          })
          .then(()=>{
            if( payload.data.type !=='Video' && payload.data.type !== 'Banner'){
              // console.log(payload.data.content);
              promises.push(itemsRef.child(payload.data.id).update({adUrl: null, videoUrl:null}));
              return contentRef.child(payload.data.id).putString(payload.data.content);
            }
            else{
              if(payload.data.type ==='Video'){
                promises.push(itemsRef.child(payload.data.id).update({adUrl: null}));
              }else if(payload.data.type ==='Banner'){
                promises.push(itemsRef.child(payload.data.id).update({videoUrl: null}));
              }
              promises.push(itemsRef.child(payload.data.id).update({content : null}));
              promises.push(contentRef.child(payload.data.id).delete());
            }

          })
          .then(()=>{
            if( payload.data.type !=='Video' && payload.data.type !== 'Banner')
              return contentRef.child(payload.data.id).getDownloadURL();
          })
          .then(downloadPath =>{
            if(payload.data.type !=='Video' && payload.data.type !== 'Banner')
              return itemsRef.child(payload.data.id).update({content : downloadPath});
            else{
              promises.push(itemsRef.child(payload.data.id).update({content : null}));
            }
          })
          .then(()=>{
            Promise.all(promises).then(function(){
              // console.log('promesas resueltas');
            },function(error){
              // console.log(error);
            });
          })
          .then(()=>{


            resolve();
          })
          .catch((error) => {
            // console.log(error);

            reject();
          });
      })
    },
    deleteItem({commit},payload) {
      return new Promise((resolve, reject) => {
        let path;
        const id = payload.id;
        path = payload.context
        // console.log(path)
        commit('setWriting', true);
        let promises = [];
        promises.push( firebase.database().ref().child(path).child(id).remove() );
        promises.push( firebase.storage().ref().child(path+'/image').child(id).delete() );
        if (path === 'posts' || path === 'static'  || path === 'faq') {
          promises.push( firebase.storage().ref().child(path+'/content').child(id).delete() );
        }
        Promise.all(promises).then(function(){
          commit('setWriting', false);
          resolve();
        },function(error){
          commit('setLoading', false);

          if(path === 'columns' || path ==='toons')
            resolve();
          else{
            // console.log(error);
            reject();
          }
        })

      });
    },
    loadItems({commit, rootState},type) {
      return new Promise((resolve, reject) => {
        let path;
        let loadCommit;
        let typeSplit = type.split(',');
        if(type === 'posts' || !type) {
          path = 'posts';
          loadCommit = 'loadPosts';
        }
        else if(type ==='static') {
          path = 'static';
          loadCommit = 'loadStatic';
        }
        else if(type ==='shop-posts') {
          path = `users/${rootState.shops.currentItem.ownerId}/shops/${rootState.shops.currentItem.id}/posts`;
          loadCommit = 'loadShopPosts';
        }
        else if(type ==='shop-about') {
          path = `users/${rootState.shops.currentItem.ownerId}/shops/${rootState.shops.currentItem.id}/about`;
          loadCommit = 'loadShopAbout';
        }
        else if(type ==='shop-multimedia') {
          path = `users/${rootState.shops.currentItem.ownerId}/shops/${rootState.shops.currentItem.id}/multimedia`;
          loadCommit = 'loadShopMultimedia';
        }
        else if(typeSplit[0] ==='shop-posts') {
          path = `users/${typeSplit[1]}/shops/${typeSplit[2]}/posts`;
          loadCommit = 'loadShopPosts';
        }
        else if(typeSplit[0] ==='shop-about') {
          path = `users/${typeSplit[1]}/shops/${typeSplit[2]}/about`;
          loadCommit = 'loadShopAbout';
        }
        else if(typeSplit[0] ==='shop-multimedia') {
          path = `users/${typeSplit[1]}/shops/${typeSplit[2]}/multimedia`;
          loadCommit = 'loadShopMultimedia';
        }
        firebase.database().ref(path).on('value',
          function (data) {
            let items = [];
            const itemList = data.val() || {};
            Object.keys(itemList).forEach(function (key) {
              items.push({
                ...itemList[key],
                id: key
              });
            });
            const currentTime = Vue.moment();
              items.sort(function(a,b){
                if(a.scores && b.scores){
                  let aStore = Vue.moment(a.scores.createdAt);
                  let bStore = Vue.moment(b.scores.createdAt);
                  let aTime = currentTime.diff(aStore, 'h') ;
                  let bTime = currentTime.diff(bStore, 'h') ;
                  // // console.log(aTime - bTime);
                  return aTime - bTime;
                }


              });
            // }
            // console.log(items);
            commit(loadCommit, items);
            resolve();
          }, function (error) {
            console.error(error);
            reject();
          }
        )
      })
    },
    getItem({commit}, payload) {
      commit('setLoading', true);
      return new Promise((resolve, reject) => {
        let path;
        let setCommit;
        const type = payload.context || 'posts';
        path = type
        setCommit = 'setPost';

        let dbRef
        if (payload.id) {
          dbRef = firebase.database().ref().child(`${path}/${payload.id}`);
        }
        if (payload.title) {
          const transformRoute = payload.title.split('_').join(' ')
          dbRef = firebase.database().ref().child(`${path}`).orderByChild('title').equalTo(transformRoute);
        }
        let item;
        dbRef.once('value', function (data) {
          if (payload.title) {
            const response = Object.values(data.val())
            item = {
              ...response[0],
              id: data.key
            };
          } else {
            item = {
              ...data.val(),
              id: data.key
            };
          }
        }).then(() => {
          // console.log(item)
          commit(setCommit, item);
          commit('setLoading', false);
          resolve();
        }, function (error) {
          // console.log(error);
          commit('setLoading', false);
          reject();
        })
      })
    },
    clearSelected({commit}){
      commit('setPost', null);
    },

    //faq

    createFaq({commit},payload){
      return new Promise((resolve, reject) => {
        let path = 'faq';
        let itemData = {
          title: payload.title || null,
          content: payload.content || null,
          type : payload.type || null,
        };
        let itemsRef = firebase.database().ref().child(path);
        // console.log(itemData);
        itemsRef.push(itemData)
          .then(()=>{
            resolve();
          })
          .catch((error) => {
            // console.log(error);
            reject();
          });
      })
    },
    updateFaq({commit},payload){
      return new Promise((resolve, reject) => {
        // let path;
        let path = 'faq';
        let itemData = {
          title: payload.title || null,
          content: payload.content || null,
          type : payload.type || null,
        };

        let itemsRef = firebase.database().ref().child(path);
        itemsRef.child(payload.id).update(itemData)
          .then(()=>{
            resolve();
          })
          .catch((error) => {
            // console.log(error);
            reject();
          });
      })
    },
    loadFaqs({commit}){
      return new Promise((resolve, reject) => {
        let path = 'faq';
        let loadCommit = 'loadFaqs';
        firebase.database().ref(path).on('value',
          function (data) {
            let items = [];
            const itemList = data.val() || {};
            Object.keys(itemList).forEach(function (key) {
              items.push({
                ...itemList[key],
                id: key
              });
            });
            // console.log(items);
            commit(loadCommit, items);
            resolve();
          }, function (error) {
            console.error(error);
            reject();
          }
        )
      })
    },
    deleteFaq({commit}, payload){
      return new Promise((resolve, reject) => {
        let path = 'faq';
        const id = payload.id;
        // console.log(path)
        let promises = [];
        promises.push( firebase.database().ref().child(path).child(id).remove() );
        Promise.all(promises).then(function(){
          commit('setWriting', false);
          resolve();
        },function(error){
          commit('setLoading', false);
          reject();
        })

      });
    },
    createMultimedia({commit, rootState} , payload) {
      return new Promise((resolve, reject) => {
        const path = `users/${rootState.shops.currentItem.ownerId}/shops/${rootState.shops.currentItem.id}/multimedia/${payload.id}`
        let itemData = {
          title: payload.title,
          description: payload.description,
          href: payload.url,
        };
        let itemsRef = firebase.database().ref().child(path);
        itemsRef.set(itemData).then(() => {
            resolve();
          }).catch((error) => {
            // console.log(error);
            reject();
          });
      })
    },
    deleteMultimedia({commit, rootState} , payload) {
      return new Promise((resolve, reject) => {
        var fileRef = firebase.storage().ref().child(`users/${rootState.shops.currentItem.ownerId}/shops/${rootState.shops.currentItem.id}/multimedia/${payload.id}`);
        // Delete the file
        fileRef.delete().then(function() {
          var dataRef = firebase.database().ref().child(`users/${rootState.shops.currentItem.ownerId}/shops/${rootState.shops.currentItem.id}/multimedia/${payload.id}`);
          dataRef.remove().then(function() {
            resolve();
          }).catch(function(error) {
            // console.log(error);
              reject();
          });
        }).catch(function(error) {
          // console.log(error);
            reject();
        });
      })
    },
  },
  getters: {
    getStatic(state){
      return state.static_pages;
    },
    getPosts(state){
      // console.log(state.posts);
      return state.posts;
    },
    getCurrentPost(state){
      // console.log(state.currentPost);
      return state.currentPost;
    },
    getLoading(state){
      return state.loading;
    },
    getFaqs(state){
      return state.faqs
    },
    getShopPosts(state){
      return state.shopPosts
    },
    getShopAbout(state){
      return state.shopAbout
    },
    getShopMultimedia(state){
      return state.shopMultimedia
    },
  },
}
